import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughCallRecordingProps = {
  node: ConversationFlowAuditLogEntry<'CALL_RECORDING_NODE_VISITED'>;
};

export function RoutedThroughCallRecording(
  _: RoutedThroughCallRecordingProps,
): JSX.Element {
  return <>Record conversation</>;
}
